import React from "react";
import DoneIcon from '@mui/icons-material/Done';

export default function OnboardingState({isActive, isCompleted, stateNumber, stateName, componentWidth, justifyContent, onClickStage, shouldUpdateAvailable}: any) {
    return (
        <div onClick={() => onClickStage && shouldUpdateAvailable && shouldUpdateAvailable(stateNumber) ? onClickStage(stateNumber) : () => {}} style={{ display: "flex", justifyContent: justifyContent || "center", alignItems: "center", width: componentWidth || '160px' }}>
            <div style={{ 
                display: "flex", 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: isActive || isCompleted ? '24px' : '24px', 
                width: isActive || isCompleted ? '24px' : '24px', 
                borderRadius: '50%', 
                border: isCompleted && '2px solid #3576E5', 
                color: "#303030", 
                backgroundColor: "red",
                fontWeight: '500',
                background:"#F2F2F2", 
                fontSize: "12px"
            }}>
                {stateNumber}
            </div>
            <div style={{ 
                display: "flex", 
                justifyContent: 'center', 
                alignItems: 'center', 
                paddingLeft: '10px', 
                color: isCompleted ? "#303030" : "#5B5B5B", 
                fontWeight: isCompleted ? '500' : '400' 
            }}>
                {stateName}
            </div>
        </div>        
    )
}

